






































































import Vue from 'vue'
import { GridOptions } from '@/types'
import { hexToRgba } from '@/services/hex-to-rgba'
import AddressResponsibleEmployeeDialog from '@/components/master-data/address/AddressResponsibleEmployeeDialog.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { TranslateResult } from 'vue-i18n'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import {
  ADDRESS_RESPONSIBLE_EMPLOYEE, COMPANY_FETCH_COMPANY_STRUCTURE,
  FETCH_ADDRESS_FUNCTION_LIST,
  FETCH_ADDRESS_RESPONSIBLE_EMPLOYEE_LIST
} from '@/store/action-types'
import { ResponsibleEmployee } from '@/model/addresses/ResponsibleEmployee'
import { AddressFunction } from '@/model/addresses/AddressFunction'
import { COMPANY_GET_BASIC_COMPANY_STRUCTURE } from '@/store/getter-types'
import { Employee } from '@/model/companyStructure/Employee'
import AddressColorCellRenderer from '@/components/cell-renderer/AddressColorCellRenderer.vue'
import { ResponseBase, VerantwortungsDataResponse } from '@/types/service-response'
import { UpdateVerantwortungsDataRequest, VerantwortungsInput } from '@/types/payload'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  gridOptions: GridOptions
  gridFrameworkComponents: Object
  overlayNoRowsTemplate: string
  functionList: AddressFunction[]
  employeeList: Employee[]
  responsibleEmployeeList: ResponsibleEmployee[]
  selectedResponsibleEmployee: ResponsibleEmployee | undefined
  showDialog: boolean
  dialogTitle: string
  showDeleteDialog: boolean
  loading: boolean
  loadingData: boolean
  cellWidth: number

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'AddressResponsibleEmployees',

  components: {
    AddressResponsibleEmployeeDialog,
    DeleteDialog,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection,
    AddressColorCellRenderer,
    ProgressCircular
  },

  props: {
    addressId: Number
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.addresses.function'), field: 'functionLabel' },
          { headerName: this.$t('masterData.addresses.employee'), field: 'employeeName' },
          { headerName: this.$t('masterData.addresses.personalNumber'), field: 'personalNumber' },
          { headerName: this.$t('masterData.addresses.shortName'), field: 'shortName'},
          { headerName: this.$t('masterData.addresses.alreadyAssignedAdddressColours'), field: 'farben', width: 700, cellRenderer: 'addressColorRenderer'},
        ]
      },
      gridFrameworkComponents: {
        addressColorRenderer: AddressColorCellRenderer
      },
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      functionList: [],
      employeeList: [],
      responsibleEmployeeList: [],
      selectedResponsibleEmployee: undefined,
      showDialog: false,
      dialogTitle: '',
      showDeleteDialog: false,
      loading: false,
      loadingData: false,
      cellWidth: 300,

      keyActions: []
    }
  },

  watch: {
    addressId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchResponsibleEmployeeList()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEnableResponsibleEmployeeButtons (): boolean {
      return !!this.selectedResponsibleEmployee
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return this.isEnableResponsibleEmployeeButtons
      } else if(action instanceof Delete) {
        return this.isEnableResponsibleEmployeeButtons
      } else {
        return false
      }
    },

    onAddResponsibleEmployeeClick (): void {
      this.dialogTitle = this.$t('masterData.addresses.addFunction').toString()
      this.selectedResponsibleEmployee = ResponsibleEmployee.createEmpty()
      this.showDialog = true
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddResponsibleEmployeeClick()
    },

    onEditResponsibleEmployeeClick (): void {
      this.dialogTitle = this.$t('masterData.addresses.editFunction').toString()
      this.showDialog = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditResponsibleEmployeeClick()
    },

    async createNewResponsibleEmployee (data: ResponsibleEmployee): Promise<void> {
      if(this.addressId) {
        const payloadData: VerantwortungsInput = {
          Mitarbeiter: data.employeeId,
          VarantwortungsArtID: data.functionId,
          ID: data.id
        }
        const payload: UpdateVerantwortungsDataRequest = {
          Action: 'Insert',
          Adresse: this.addressId,
          Data: payloadData
        }
        try {
          this.loading = true
          const response: ResponseBase = await this.$store.dispatch(ADDRESS_RESPONSIBLE_EMPLOYEE, payload)
          if (response && !response.IsError) {
            this.loading = false
            this.closeDialog()
            this.selectedResponsibleEmployee = undefined
            //@ts-ignore
            this.$refs.dataGrid.instance.selectRows([])
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.fetchResponsibleEmployeeList()
          } else {
            this.loading = false
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch (e) {
          this.loading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    async editResponsibleEmployee (data: ResponsibleEmployee): Promise<void> {
      if(this.addressId) {
        const payloadData: VerantwortungsInput = {
          Mitarbeiter: data.employeeId,
          VarantwortungsArtID: data.functionId,
          ID: data.id
        }
        const payload: UpdateVerantwortungsDataRequest = {
          Action: 'Update',
          Adresse: this.addressId,
          Data: payloadData
        }
        try {
          this.loading = true
          const response: ResponseBase = await this.$store.dispatch(ADDRESS_RESPONSIBLE_EMPLOYEE, payload)
          if (response && !response.IsError) {
            this.loading = false
            this.closeDialog()
            this.selectedResponsibleEmployee = undefined
            //@ts-ignore
            this.$refs.dataGrid.instance.selectRows([])
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.fetchResponsibleEmployeeList()
          } else {
            this.loading = false
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch (e) {
          this.loading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    closeDialog (): void {
      this.showDialog = false
      this.dialogTitle = ''
    },

    onDeleteResponsibleEmployeeClick (): void {
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteResponsibleEmployeeClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    async onDeleteDialogSave (): Promise<void> {
      if(this.addressId && this.selectedResponsibleEmployee) {
        const payloadData: VerantwortungsInput = {
          Mitarbeiter: this.selectedResponsibleEmployee.employeeId,
          VarantwortungsArtID: this.selectedResponsibleEmployee.functionId,
          ID: this.selectedResponsibleEmployee.id
        }
        const payload: UpdateVerantwortungsDataRequest = {
          Action: 'Delete',
          Adresse: this.addressId,
          Data: payloadData
        }
        try {
          const response: ResponseBase = await this.$store.dispatch(ADDRESS_RESPONSIBLE_EMPLOYEE, payload)
          if (response && !response.IsError) {
            this.onDeleteDialogClose()
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.fetchResponsibleEmployeeList()
          } else {
            this.onDeleteDialogClose()
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }

          this.selectedResponsibleEmployee = undefined
          //@ts-ignore
          this.$refs.dataGrid.instance.selectRows([])
        } catch {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    onResponsibleEmployeeRowClicked (params: any): void {
      this.selectedResponsibleEmployee = params.data
    },

    onRowDblClick (params: any): void {
      this.selectedResponsibleEmployee = params.data
      this.onEditResponsibleEmployeeClick()
    },

    async fetchResponsibleEmployeeList (): Promise<void> {
      try {
        this.loadingData = true
        const response: VerantwortungsDataResponse = await this.$store.dispatch(FETCH_ADDRESS_RESPONSIBLE_EMPLOYEE_LIST, this.addressId)
        this.loadingData = false
        if (response && !response.IsError) {
          this.responsibleEmployeeList = ResponsibleEmployee.createFromResponse(response.Data)
          let maxFarbenLength: number = 0
          this.responsibleEmployeeList.forEach((item: ResponsibleEmployee) => {
            if(item.farben.length > maxFarbenLength) {
              maxFarbenLength = item.farben.length
            }
          })
          this.cellWidth = maxFarbenLength > 0 ? (maxFarbenLength * 38) + 20 : 300

        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loadingData = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
      this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList.filter((item: Employee) => item.planbar)
      this.functionList = await this.$store.dispatch(FETCH_ADDRESS_FUNCTION_LIST, this.addressId)
    }

  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    this.fetchData()
    this.fetchResponsibleEmployeeList()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
